import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  /**
   * Specify your server-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars.
   */
  server: {
    NODE_ENV: z.enum(["development", "test", "production"]),
    INVESTOR_PORTAL_CLIENT_ID: z.string().min(1).optional(),
    SELLER_PORTAL_CLIENT_ID: z.string().min(1).optional(),
  },

  /**
   * Specify your client-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars. To expose them to the client, prefix them with
   * `NEXT_PUBLIC_`.
   */
  client: {
    // NEXT_PUBLIC_CLIENTVAR: z.string(),
    NEXT_PUBLIC_AUTH_URL: z.string().min(1),
    NEXT_PUBLIC_CONFIG_SERVICE_URL: z.string().min(1),
    NEXT_PUBLIC_SUPPORT_SERVICE_URL: z.string().min(1),
    NEXT_PUBLIC_CAMPAIGN_SERVICE_URL: z.string().min(1),
  },

  /**
   * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
   * middlewares) or client-side so we need to destruct manually.
   */
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    // NEXT_PUBLIC_CLIENTVAR: process.env.NEXT_PUBLIC_CLIENTVAR,
    NEXT_PUBLIC_AUTH_URL: process.env.NEXT_PUBLIC_AUTH_URL,
    NEXT_PUBLIC_CONFIG_SERVICE_URL: process.env.NEXT_PUBLIC_CONFIG_SERVICE_URL,
    NEXT_PUBLIC_SUPPORT_SERVICE_URL:
      process.env.NEXT_PUBLIC_SUPPORT_SERVICE_URL,
    NEXT_PUBLIC_CAMPAIGN_SERVICE_URL:
      process.env.NEXT_PUBLIC_CAMPAIGN_SERVICE_URL,
    INVESTOR_PORTAL_CLIENT_ID: process.env.INVESTOR_PORTAL_CLIENT_ID,
    SELLER_PORTAL_CLIENT_ID: process.env.SELLER_PORTAL_CLIENT_ID,
  },
  /**
   * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation. This is especially
   * useful for Docker builds.
   */
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  /**
   * Makes it so that empty strings are treated as undefined. `SOME_VAR: z.string()` and
   * `SOME_VAR=''` will throw an error.
   */
  emptyStringAsUndefined: true,
});
